/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aroma_SamplingsInputs */

const vi_nav_aroma_samplings = /** @type {(inputs: Nav_Aroma_SamplingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hương chè`)
};

/**

* @param {Nav_Aroma_SamplingsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_aroma_samplings = /** @type {((inputs?: Nav_Aroma_SamplingsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aroma_SamplingsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_aroma_samplings(inputs)
});